export default "__VITE_ASSET__D5htD7y3__"